<div class="cg-dialog">
  <button
    cignaButton="link inline no-underline"
    class="cg-dialog__close"
    (click)="close()"
  >
    Close
    <cigna-icon class="cml-close-icon" type="close-thin"></cigna-icon>
  </button>

  <h2 class="cg-dialog__header">Site Tour</h2>

  <iframe
    class="limelightIframe"
    src="https://link.videoplatform.limelight.com/media/?mediaId=56e31043818740d38c45483883071d52&width=900&playerForm=LVPPlayer&embedMode=html&htmlPlayerFilename=limelightjs-player.js"
  ></iframe>
</div>
